module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_8004.2bce3b5f.png";